/**
 * 사주 입력 시트 (시안 03 B1: 운세 카드 「생일 알려주기」, 나 탭 「수정하기」, 1:1 에서 이모의 재요청).
 *
 *   손잡이 → [이모 32 + 「생일 알려주면 매일 아침 {호칭} 것도 따로 봐줄게.」] → BirthForm → 「이모한테 알려주기」
 *
 * 카운터의 대화 안 카드와 같은 BirthForm 입니다. 저장은 PATCH /api/me/saju.
 */
import { useState } from 'react';
import { BottomSheet } from '../BottomSheet.jsx';
import { errorMessageOf } from '../../api/client.js';
import * as meApi from '../../api/me.js';
import { BirthForm } from './BirthForm.jsx';
import { Avatar } from '../Avatar.jsx';
import { useSession } from '../../stores/session.js';

export function BirthSheet({ open, initialBirth = null, title = '사주 정보', onClose, onSaved }) {
    const displayName = useSession((state) => state.user?.displayName) || '단골';
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    async function save(payload) {
        setBusy(true);
        setError(null);
        try {
            const { saju } = await meApi.updateMySaju(payload);
            onSaved(saju);
        } catch (requestError) {
            setError(errorMessageOf(requestError, '사주 정보를 저장하지 못했어요. 잠시 후 다시 시도해 주세요.'));
        } finally {
            setBusy(false);
        }
    }

    return (
        <BottomSheet open={open} onClose={onClose} label={title}>
            <div className="flex items-start gap-2.5">
                <Avatar memberKey="imo" size={32} />
                <p className="m-0 font-serif text-[16px] leading-[26px]">
                    생일 알려주면 매일 아침 {displayName} 것도 따로 봐줄게.
                </p>
            </div>
            {/* 시트를 열 때마다 저장된 값으로 다시 채웁니다 */}
            {open ? (
                <BirthForm
                    initialBirth={initialBirth}
                    submitLabel="이모한테 알려주기"
                    busy={busy}
                    error={error}
                    onSubmit={save}
                />
            ) : null}
        </BottomSheet>
    );
}
